module.exports = __webpack_public_path__ + "static/author-1-c3e8f0340950876523107bb13e098cf1.jpg";